module.exports = __webpack_public_path__ + "img/social-share.672b1a47.svg";